export enum E_EstadoTipoEvaluacionLIO {
  Estandar = 1,
  SubEstandar = 2,
  NoAplica = 3,
  Aplica = 4,
}
